import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'
import InputElement from '../../utils/input'

const mapStateToProps = (state, ownProps) => {
    const imeis = state.accountImeis.filter(i => i.accountId === ownProps.installation.accountId && i.available)
    const answer = state.answers.find(a => a.groupQuestionId === ownProps.groupQuestionId && a.installationId === ownProps.installation.id)
    let answerValue = null
    if (answer) {
        answerValue = state.answerValues.find(av => av.answerId === answer.id)
    }
    return {
        answer,
        answerValue,
        imeis
    }
}

const ImeiQuestion = ({ dispatch, question, answer, answerValue, installation, imeis }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('account-imeis', 'LIST')))
    }, [dispatch])

    const imeiOptions = imeis.map(i => (
        { value: i.imei, label: i.imei }
    ))
    // the saved IMEI is unavailable to the list, but it has to stay selectable or Save would clear it
    const savedImei = answerValue?.textValue
    if (savedImei && !imeiOptions.find(o => o.value === savedImei)) {
        imeiOptions.unshift({ value: savedImei, label: savedImei })
    }

    const renderNotes = () => {
        if (answerValue?._computed.statusValue === 'REJECTED') {
            return (
                <div className="rejected-notes">
                    <span className="error-label"> Error</span>
                    <p className="notes">
                        {answerValue.notes}
                    </p>
                </div>
            )
        }
        return null
    }

    let inputId = `answer_${answer?.id}`
    if (answerValue) {
        inputId = inputId + '_' + answerValue.id
    }
    return (
        <>
            <InputElement
                type="valueSelect"
                id={inputId}
                options={imeiOptions}
                allowClear
                label={question.label}
                infoIcon={question?.instructions ? 'circle-info' : null}
                instructions={question?.instructions}
                default={answerValue?.textValue}
                extraClass={`with-status ${answer?._computed.statusValue.toLowerCase()}`}
                readOnly={installation?._computed.statusDisplay === 'Submitted' ? true : false} />
            {renderNotes()}
        </>
    )
}

export default connect(mapStateToProps)(ImeiQuestion)
